const removeHolidayToast = (state = null, action) => {
  if (action.type === "SET_REMOVE_HOLIDAY_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_REMOVE_HOLIDAY_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default removeHolidayToast;
